module.exports = __webpack_public_path__ + "img/ic-jcbcard.813d4b9d.svg";